<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Mensal
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green lighten-1" outlined>
          <v-col cols="10">
            <v-card-text>
              <h4>Turma: {{ gestaoDeAula.turma?.descricao }}</h4>
              <h4>
                Disciplina:
                {{
                  gestaoDeAula.is_polivalencia === 1
                    ? gestaoDeAula.disciplina
                    : gestaoDeAula.disciplina.descricao
                }}
              </h4>
              <h4>
                Professor:
                {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
              </h4>
            </v-card-text>
          </v-col>
          <v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  x-small
                  class="ml-1 white--text"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  @click="() => verHistoricoPlanos()"
                >
                  <span>Histórico do lancamento de planos</span>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-card>
      </v-col>
      <v-col cols="12 text-center" class="pt-2">
        <template>
          <v-toolbar>
            <v-tabs dark v-model="form.mes_id" background-color="primary" grow>
              <v-tab
                v-for="item of $constants.mesesPlanoMensal"
                :key="item.id"
                @click="() => editarPlano(item.id)"
              >
                <v-badge v-if="form.mes_id === item.id" color="yellow lighten-1">
                  {{ item?.descricao }}
                </v-badge>
                <div v-else>{{ item.descricao }}</div>
              </v-tab>
            </v-tabs>
          </v-toolbar>
        </template>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form
        @submit.prevent="handleSubmit(createOrUpdate)"
        v-if="loadPlano"
        :disabled="submittingForm"
      >
        <v-row>
          <v-col cols="12">
            <e-label>Anexar plano mensal</e-label>
            <div class="dropboxStyles mt-2">
              <v-row class="align-end">
                <v-col cols="12" sm="8" md="8" class="py-0 pr-1">
                  <v-file-input
                    v-model="plano_mensal[mesAtual]"
                    accept="application/pdf"
                    chips
                    dense
                    solo
                    label="Plano Mensal"
                    prepend-icon="mdi-file"
                    chip-color="red"
                    @change="onFileSelected"
                    class="file-input-mobile"
                    hide-details
                    :clearable="false"
                  ></v-file-input>
                </v-col>

                <v-col cols="12" sm="4" md="4" class="py-0" v-if="pathAtual || form.path">
                  <v-row no-gutters>
                    <v-col cols="2" class="pr-1 d-flex justify-center align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="removerPlanoMensal()"
                            color="red"
                            dark
                            fab
                            small
                            v-bind="attrs"
                            v-on="on"
                            aria-label="Remover plano"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Remover plano</span>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="6" class="pl-1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="downloadPlanoMensal()"
                            color="red lighten-5"
                            v-bind="attrs"
                            v-on="on"
                            block
                            height="40px"
                          >
                            <v-icon color="red lighten-1" small>fa fa-file-pdf</v-icon>
                            <span class="ml-2 d-none d-sm-inline">Baixar</span>
                          </v-btn>
                        </template>
                        <span>Baixar plano</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" v-if="form.path || pathAtual">
                  <v-alert dense color="green" icon="mdi-check-circle" text border="left">
                    PLANO MENSAL EM PDF ENVIADO
                    <br />Última alteração do PDF:
                    {{ form.data_envio_pdf ? dateFormat(form.data_envio_pdf) : "- - -" }}
                    {{ form.data_envio_pdf ? dateFormatHour(form.data_envio_pdf) : "- - -" }}
                    <br />
                  </v-alert>
                </v-col>
              </v-row>
            </div>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Tematica" rules="required" v-slot="{ errors }">
              <e-label>{{
                gestaoDeAula.disciplina.descricao == "LÍNGUA PORTUGUESA"
                  ? "PRÁTICA DE LINGUAGEM"
                  : "UNIDADE TEMÁTICA"
              }}</e-label>
              <v-textarea solo dense v-model="form.tematica" :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Objeto_conhecimento" rules="required" v-slot="{ errors }">
              <e-label>OBJETOS DO CONHECIMENTO</e-label>
              <v-textarea solo dense v-model="form.objeto_conhecimento" :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Habilidades_BNCC" rules="required" v-slot="{ errors }">
              <e-label>HABILIDADES DA BNCC/CURRICULO</e-label>
              <v-textarea solo dense v-model="form.habilidades_bncc" :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Habilidades_Saeb" rules="required" v-slot="{ errors }">
              <e-label>HABILIDADES SAEB</e-label>
              <v-textarea solo dense v-model="form.saeb" :error-messages="errors" />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
              <e-label>METODOLOGIAS</e-label>
              <v-textarea solo dense v-model="form.metodologia" :error-messages="errors" />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-col cols="12">
          <v-row>
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              >Enviar Dados</v-btn
            >
          </v-row>
        </v-col>
      </form>
    </ValidationObserver>
    <e-drawer-planos-lancados
      v-model="openDrawer"
      :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
      :mes_id="parseInt(form.mes_id, 10)"
      :disciplina_id="parseInt($route.params.disciplinaId, 10)"
      @planoRestaurado="loadData"
    />
  </main-template>
</template>

<script>
import { dateFormat, dateFormatHour } from "@/plugins/filters";
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      submittingForm: false,
      form: {
        mes_id: 0,
        disciplina_id: null,
      },
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
        disciplinas: [],
      },
      loadPlano: true,
      data_envio_pdf: null,
      path: null,
      plano_mensal: [null, null, null, null],
      dateFormat,
      dateFormatHour,
      pathAtual: null,
    };
  },
  computed: {
    mesAtual() {
      return this.form.mes_id;
    },
  },
  methods: {
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async editarPlano(mes_id) {
      this.loadPlano = false;
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplinaId;

        const obrigatorios = [
          this.form.tematica,
          this.form.objeto_conhecimento,
          this.form.habilidades_bncc,
          this.form.saeb,
          this.form.metodologia,
        ];

        const todosPreenchidos = obrigatorios.every(
          (campo) => campo && campo.toString().trim() !== ""
        );
        if (todosPreenchidos) {
          await this.$services.planosMensaisService.createOrUpdate(this.form);
        }
        const response = await this.$services.planosMensaisService.planoMensal(
          gestaoDeAulaId,
          mes_id,
          this.disciplinaId
        );
        if (response !== "") {
          this.form = response;
          this.pathAtual = response.path;
          this.loadPlano = true;
          this.$loaderService.close();
          return;
        }
        this.form = {
          mes_id,
        };
        this.pathAtual = null;
        this.loadPlano = true;
      } catch (error) {
        this.$handleError(error);
      }
      this.loadPlano = true;
      this.$loaderService.close();
    },
    async createOrUpdate() {
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        const { mes_id } = this.form;
        this.form.mes_id = mes_id;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplinaId;
        await this.$services.planosMensaisService.createOrUpdate(this.form);
        this.$toast.success("Plano mensal salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async loadData() {
      const { gestaoDeAulaId } = this.$route.params;
      this.disciplinaId = parseInt(this.$route.params.disciplinaId, 10);
      const { meses } = this.form;

      try {
        this.$loaderService.open("Carregando dados...");
        this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizar(gestaoDeAulaId);

        const response = await this.$services.planosMensaisService.planoMensal(
          gestaoDeAulaId,
          meses,
          this.disciplinaId
        );

        if (this.gestaoDeAula.disciplinas.length > 0) {
          const disciplina = this.gestaoDeAula.disciplinas.filter((i) => {
            return i.id === this.disciplinaId;
          });

          this.gestaoDeAula.disciplina = disciplina[0].descricao;
        }

        if (response !== "") {
          this.form = response;
        }
        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async onFileSelected() {
      const mesId = this.form.mes_id;
      const file = this.plano_mensal[mesId];

      if (file) {
        const maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
          this.$toast.danger("O tamanho máximo permitido para o plano é 10MB.");
          this.$set(this.plano_mensal, mesId, null);
          return;
        }

        try {
          const gestaoId = this.$route.params.gestaoDeAulaId;
          const disciplinaId = this.$route.params.disciplinaId;

          const response = await this.$services.planosMensaisService.planoMensalPDF(
            gestaoId,
            mesId,
            disciplinaId,
            file
          );

          this.form.path = response.path;
          this.pathAtual = response.path;
          this.$set(
            this.form,
            "data_envio_pdf",
            response.data_envio_pdf || new Date().toISOString()
          );
          this.$toast.success("Plano enviado com sucesso!");
        } catch (error) {
          this.$handleError(error);
        } finally {
          this.$loaderService.close();
        }
      }
    },

    async downloadPlanoMensal() {
      this.$loaderService.open("Baixando plano mensal...");

      const { gestaoDeAulaId, disciplinaId } = this.$route.params;
      try {
        await this.$services.planosMensaisService.planoMensalDownload(
          gestaoDeAulaId,
          this.mesAtual,
          disciplinaId
        );
      } catch (error) {
        this.$toast.danger("Falha ao baixar o plano.");
      }
      this.$loaderService.close();
    },

    async removerPlanoMensal() {
      this.$loaderService.open("Removendo plano mensal...");

      const { gestaoDeAulaId, disciplinaId } = this.$route.params;

      try {
        await this.$services.planosMensaisService.removerPlanoMensal(
          gestaoDeAulaId,
          this.mesAtual,
          disciplinaId
        );

        this.form.path = null;
        this.pathAtual = null;
        this.$set(this.plano_mensal, this.mesAtual, null);

        this.$toast.success("Plano removido com sucesso!");

        await this.editarPlano(this.mesAtual);
      } catch (error) {
        this.$toast.danger("Falha ao remover o plano.");
      } finally {
        this.$loaderService.close();
      }
    },
  },
};
</script>

<style></style>
